import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['tooltip']

  connect() {
    this.popoverInstances = []

    document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
      if (!bootstrap.Popover.getInstance(el)) {
        this.popoverInstances.push(new bootstrap.Popover(el))
      }
    })

    this.tooltipTargets.forEach((tooltip) => {
      if (!bootstrap.Popover.getInstance(tooltip)) {
        this.popoverInstances.push(new bootstrap.Popover(tooltip, { container: 'body' }))
      }
    })
  }

  disconnect() {
    this.popoverInstances.forEach((instance) => instance.dispose())
    this.popoverInstances = []
  }
}
